/**
 * Router-shell de /orcamentos.
 *
 *   /orcamentos              -> redireciona para /crm (o CRM virou a raiz comercial)
 *   /orcamentos/:orcamentoId -> Detalhe do orcamento (editor de ambientes/itens)
 *
 * O board de Leads (CRM) e o cockpit do lead migraram para o shell proprio
 * de /crm. Este shell serve apenas o Detalhe do orcamento; a raiz redireciona
 * para /crm para nao deixar uma URL orfa.
 *
 * `<Routes location={location} key={location.pathname}>` forca remount da
 * arvore interna sempre que a URL muda (hooks pesados do Detalhe + matching
 * herdado do AnimatePresence outer).
 */
import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import OrcamentoDetalhe from "./Detalhe";

export default function Orcamentos() {
  const location = useLocation();
  return (
    <Routes location={location} key={location.pathname}>
      <Route index element={<Navigate to="/crm" replace />} />
      <Route path=":orcamentoId" element={<OrcamentoDetalhe />} />
    </Routes>
  );
}
